<template>
  <app-agb></app-agb>
</template>

<script>
import AGB from '@/components/global_comps/AGB.vue'

export default {
  components: {
    // eslint-disable-next-line
    "app-agb": AGB
  },
  
}
</script>
